// import Tooltip from '@mui/material/Tooltip';
import React, { useEffect, useRef, useState } from 'react'
import '../assets/css/comment-popup.scss'
import Editor from '../common/Editor'
import { convertDateTimeToLocal, convertDateToLocal } from '../utils/customUtil'
import { SelectedFilePreview } from './SelectedFilePreview'
import { ReactComponent as Attach } from '../assets/icons/attach.svg'
import { ReactComponent as IconClose } from '../assets/icons/close.svg'
import { ReactComponent as IconResolve } from '../assets/icons/custom/resolve.svg'
import { ReactComponent as ProfileIcon } from '../assets/images/pro_pic_default.svg'

const CommentPopUp = ({
    idName,
    addNewPost,
    canvas,
    onHide,
    userInfo,
    commentCanvasId,
    listOfComments,
    commentPositionNumber,
    memberList
}) => {
    const [selectedFiles, setSelectedFiles] = useState([])
    const [commentError, setCommentError] = useState('')
    const [comment, setComment] = useState('')
    const [showFooter, setShowFooter] = useState(true)
    const [commentObj, setCommentObj] = useState({})
    const postInputRef = useRef(null)

    useEffect(() => {
        if (listOfComments.length > 0) {
            const artBoardComment = listOfComments.find(
                (item) =>
                    parseInt(item.postPositionNo) ===
                    parseInt(commentPositionNumber)
            )
            setCommentObj(artBoardComment)
        }
    }, [commentPositionNumber])

    const onMultipleFileSelect = (e, docType) => {
        const files = Array.from(e.target.files)
        const fileList = [...selectedFiles]
        files.map((item) => {
            const data = {
                name: item.name,
                docMimeType: item.type,
                documentType: docType,
                print: false
            }
            const reader = new FileReader()
            reader.readAsDataURL(item)
            reader.onload = async () => {
                data.base64Str = reader.result
                fileList.push(data)
            }
        })

        setTimeout(() => {
            setSelectedFiles(fileList)
        }, 500)
    }

    const removeFile = (index) => {
        const fileList = selectedFiles.filter((file, i) => i !== index)
        setSelectedFiles(fileList)
    }

    const renderFilePreview = (
        fileList = selectedFiles,
        showRemoveOption = true
    ) => {
        if (fileList.length > 0) {
            return (
                <div
                    className='uploaded-files-n-photos custom-scrollbar'
                    key={fileList.length}
                >
                    {fileList.map((file, i) => {
                        return (
                            <SelectedFilePreview
                                showRemoveOption={showRemoveOption}
                                file={file}
                                key={i}
                                index={i}
                                remove={removeFile}
                            />
                        )
                    })}
                </div>
            )
        }
    }

    const closeModal = () => {
        if (commentObj && Object.keys(commentObj).length > 0) {
            onHide(false)
        } else {
            const activeObject = canvas?.getActiveObject()
            canvas.remove(activeObject)
            onHide(false)
        }
    }

    const handelSubmit = () => {
        const postData = {}
        postData.identifier = commentNumber
        postData.comment = comment
        canvas?.discardActiveObject().requestRenderAll()
        canvas.calcOffset()
        canvas.fire('object:modified')
        onHide(false)
    }

    const handlePost = () => {
        if (!comment) {
            setCommentError('Message Required!')
        } else {
            let newComment = comment
            const regex = /@@@__[0-9]*\^\^__/gm
            const idWithCharacterList = newComment.match(regex)
            const mentionIds = []
            if (idWithCharacterList !== null) {
                for (const item of idWithCharacterList) {
                    const memberId = item.slice(5, -4)
                    mentionIds.push(parseInt(memberId))
                }
            }
            newComment = newComment
                .split('@@@__')
                .join("<span class='heighlight-mention' id='")
            newComment = newComment.split('^^__').join("'>@")
            newComment = newComment.split('@@@^^^').join('</span>')

            const postData = {
                documentDTOList: selectedFiles,
                text: newComment.trim(),
                taggedUserIdList: mentionIds,
                artBoardId: commentCanvasId
            }
            if (commentObj && Object.keys(commentObj).length > 0) {
                postData.postId = commentObj.id
                postData.postPositionNo = commentObj.postPositionNo
            } else {
                postData.postPositionNo = commentNumber
            }
            addNewPost(postData)
            handelSubmit()
        }
    }

    const renderReplyList = () => {
        return commentObj?.commentList?.map((item, index) => {
            return (
                <div className='single-reply' key={`replay_${index}`}>
                    <div className='comment-title'>
                        <span>{item?.postedBy?.name}</span>
                        <span>{item?.artBoardName}</span>
                        <span>
                            {convertDateTimeToLocal(
                                item.dateAdded?.split('T')[0],
                                item.dateAdded?.split('T')[1],
                                'hh:mm A DD MMM, YYYY'
                            )}
                        </span>
                    </div>
                    <div className='comments-description'>
                        <p
                            dangerouslySetInnerHTML={{
                                __html: item.text ? item.text : ''
                            }}
                        />
                        {renderFilePreview(item.docList, false)}
                    </div>
                </div>
            )
        })
    }

    const renderCommentInfo = () => {
        if (commentObj && Object.keys(commentObj).length > 0) {
            return (
                <div className='all-comments-body custom-scrollbar'>
                    <div className='comments-popup-header'>
                        <p>Comments</p>
                        <div className='close-check'>
                            {/*<Tooltip title='Resolve' placement='top' arrow>*/}
                                <span onClick={handleResolve}>
                                    <IconResolve />
                                </span>
                            {/*</Tooltip>*/}
                            <p onClick={closeModal} className='comment-close'>
                                <IconClose />
                            </p>
                        </div>
                    </div>
                    <div className='single-comment-container'>
                        {commentObj?.postPositionNo && (
                            <span className='comment-number'>
                                {commentObj?.postPositionNo}
                            </span>
                        )}
                        <div className='comment-title'>
                            <span>{commentObj?.postedBy?.name}</span>
                            {commentObj?.artBoardName && (
                                <span>{commentObj?.artBoardName}</span>
                            )}
                            <span>
                                {convertDateToLocal(
                                    commentObj?.dateAdded,
                                    'hh:mm A DD MMM, YYYY'
                                )}
                            </span>
                        </div>
                        <div className='comments-description'>
                            <p
                                dangerouslySetInnerHTML={{
                                    __html: commentObj?.text
                                        ? commentObj?.text
                                        : ''
                                }}
                            />
                            {renderFilePreview(commentObj?.docList, false)}
                        </div>
                        <div className='reply-list'>{renderReplyList()}</div>
                    </div>
                </div>
            )
        }
    }

    const handleResolve = () => {
        const activeObject = canvas?.getActiveObject()
        canvas.remove(activeObject)
        canvas.fire('object:modified')
        onHide(false)
    }

    return (
        <div
            className='artboard-comment-modal'
            key={`popup_${idName}`}
            id={`popup_${idName}`}
        >
            {commentObj && Object.keys(commentObj).length === 0 && (
                <div className='all-comments-body custom-scrollbar'>
                    <div className='comments-popup-header'>
                        <p>Comments</p>
                        <p onClick={closeModal} className="comment-close">
                            <IconClose />
                        </p>
                    </div>
                </div>
            )}
            {renderCommentInfo()}
            <div
                className={
                    showFooter
                        ? 'comments-container expand'
                        : 'comments-container'
                }
            >
                <div className='artboard-comment-box'>
                    {userInfo?.profilePicDocument?.docUrl && (
                        <img
                            src={userInfo?.profilePicDocument?.docUrl}
                            alt='profile'
                            className='profile'
                        />
                    )}
                    {!userInfo?.profilePicDocument?.docUrl && <ProfileIcon />}

                    <Editor
                        onChange={setComment}
                        value={comment}
                        onClick={() => setShowFooter(true)}
                        memberList={memberList}
                        addClass={showFooter}
                    />
                </div>
                {renderFilePreview()}
                {showFooter && (
                    <div className='artboard-comment-footer'>
                        <span className='upload'>
                            <label htmlFor={`comment_${idName}`}>
                                <Attach />
                            </label>
                            <input
                                type='file'
                                id={`comment_${idName}`}
                                name='attachment'
                                multiple
                                onChange={(e) =>
                                    onMultipleFileSelect(
                                        e,
                                        'ACCESSORIES_DESIGN'
                                    )
                                }
                            />
                        </span>
                        <span className='action-buttons'>
                            <button onClick={closeModal}>CANCEL</button>
                            <button onClick={handlePost}>POST</button>
                        </span>
                    </div>
                )}
            </div>
        </div>
    )
}

export default CommentPopUp
